module.exports = "/_next/static/images/d563241a516ca689b998bf0431b3e93a-parcelar_fatura.png";